import { Injectable } from '@angular/core';

/**
 * Central registry of all in-memory HTTP GET caches.
 *
 * App mein ek se zyada cache interceptors hain (shared + activity). Har interceptor
 * apni ALAG Map rakhta hai (zaroori hai — agar do chained interceptors ek hi Map share
 * karein to shared interceptor ka in-flight observable downstream interceptor utha leta
 * hai aur backend kabhi hit nahi hota). Yeh service har interceptor ki Map ko register
 * kar leti hai taake ek hi `clear()` se SAARE caches nuke ho jayein — yehi cheez full
 * page reload jaisa fresh data deti hai, bina app reload kiye.
 */
@Injectable({ providedIn: 'root' })
export class HttpCacheStore {
  private readonly caches = new Set<Map<string, any>>();

  /** Naya cache banata aur register karta hai. Har interceptor ek baar call kare. */
  createCache(): Map<string, any> {
    const cache = new Map<string, any>();
    this.caches.add(cache);
    return cache;
  }

  /** Saare registered caches clear kar deta hai. */
  clear(): void {
    this.caches.forEach(cache => cache.clear());
  }
}
